import { render, staticRenderFns } from "./ActionsTable.vue?vue&type=template&id=191e3dd4"
import script from "./ActionsTable.vue?vue&type=script&lang=ts"
export * from "./ActionsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports